import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth.jsx";
import api from "@/lib/api";

export default function SettingsPage() {
  const { user, logout, refresh } = useAuth();
  const [pw, setPw] = useState({ old_password: "", new_password: "" });

  const save = async () => {
    try {
      await api.post("/auth/change-password", pw);
      toast.success("Password updated");
      setPw({ old_password: "", new_password: "" });
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="px-5 lg:px-10 py-8 max-w-3xl mx-auto">
      <h1 className="text-3xl font-bold text-brand-navy">Settings</h1>
      <div className="mt-6 bg-white rounded-2xl border border-brand-borderc p-6 overflow-hidden">
        <h2 className="text-lg font-semibold text-brand-navy">Profile</h2>
        <div className="mt-3 text-sm grid grid-cols-1 sm:grid-cols-2 gap-3 min-w-0">
          <div className="min-w-0"><div className="text-brand-muted">Name</div><div className="font-semibold text-brand-navy break-words">{user?.name}</div></div>
          <div className="min-w-0"><div className="text-brand-muted">Email</div><div className="font-semibold text-brand-navy break-all">{user?.email}</div></div>
          <div className="min-w-0"><div className="text-brand-muted">Plan</div><div className="font-semibold capitalize text-brand-navy">{user?.plan}</div></div>
          <div className="min-w-0"><div className="text-brand-muted">Period ends</div><div className="font-semibold text-brand-navy break-words">{user?.period_end ? new Date(user.period_end).toLocaleString() : "—"}</div></div>
        </div>
      </div>

      <div className="mt-6 bg-white rounded-2xl border border-brand-borderc p-6 overflow-hidden">
        <h2 className="text-lg font-semibold text-brand-navy">Change password</h2>
        <div className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-3 min-w-0">
          <input data-testid="change-pw-old" type="password" placeholder="Current password" value={pw.old_password} onChange={(e) => setPw({ ...pw, old_password: e.target.value })} className="w-full min-w-0 px-3 py-2.5 rounded-xl border border-brand-borderc focus:border-brand-purple outline-none" />
          <input data-testid="change-pw-new" type="password" placeholder="New password (min 6)" value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} className="w-full min-w-0 px-3 py-2.5 rounded-xl border border-brand-borderc focus:border-brand-purple outline-none" />
        </div>
        <button data-testid="change-pw-btn" onClick={save} className="mt-4 btn-primary-gradient rounded-full px-5 py-2.5 text-sm font-semibold">Update password</button>
      </div>

      <div className="mt-6 bg-white rounded-2xl border border-brand-borderc p-6">
        <h2 className="text-lg font-semibold text-brand-navy">Sign out</h2>
        <p className="text-sm text-brand-muted">You'll need to sign back in to access DraftVoice.</p>
        <button onClick={logout} className="mt-4 px-5 py-2.5 rounded-full bg-red-50 text-red-600 text-sm font-semibold hover:bg-red-100">Log out</button>
      </div>
    </div>
  );
}
